import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  getOrgInvitation,
  GetOrgInvitationInput,
} from '@/features/org/api/get-org-invitation';

const getOrgInvitationQueryKey = (invitationToken: string) => [
  'orgInvitation',
  { invitationToken },
];

type Props = GetOrgInvitationInput &
  Omit<
    UseQueryOptions<Awaited<ReturnType<typeof getOrgInvitation>>>,
    'queryKey' | 'queryFn'
  >;

export const useGetOrgInvitation = ({ invitationToken, ...props }: Props) => {
  return useQuery({
    ...props,
    queryKey: getOrgInvitationQueryKey(invitationToken),
    queryFn: () => getOrgInvitation({ invitationToken }),
  });
};
